import { toast } from 'react-toastify'

const getServerMessage = e => (
    e?.response?.data?.error?.errorMessage ||
    e?.response?.data?.error?.errorCode ||
    e?.response?.status ||
    "Внутренняя ошибка"
)

const queryConfig = {
    queries: {
        useErrorBoundary: false,
        refetchOnWindowFocus: false,
        retry(failureCount, error) {
            if (error.status === 404) return false
            else if (failureCount < 2) return true
            else return false
        },
        onError: e => {
            toast.error(getServerMessage(e))
        }
    },
    mutations: {
        onError: e => {
            toast.error(getServerMessage(e))
        }
    }
}

export {
    queryConfig
}